/**
 * CompanionProfile resolver.
 *
 * Minimal implementation: resolves the active companion profile from a
 * `?companion=<id>` URL query param (verification-only) or defaults to Toto.
 *
 * No admin editor. No runtime swapping. No cross-licensee management.
 * When a real deployment story emerges, this resolver becomes the single
 * point where a persistent profile source (per-deployment config) is wired in.
 */
import totoProfile from "./profiles/toto";
import morrowProfile from "./profiles/morrow";

const REGISTRY = {
  toto: totoProfile,
  morrow: morrowProfile,
};

const DEFAULT_ID = "toto";

function readQueryId() {
  if (typeof window === "undefined") return null;
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get("companion");
  } catch {
    return null;
  }
}

export function resolveCompanionProfile() {
  const queryId = readQueryId();
  if (queryId && REGISTRY[queryId]) return REGISTRY[queryId];
  return REGISTRY[DEFAULT_ID];
}

export function getCompanionProfileById(id) {
  return REGISTRY[id] || REGISTRY[DEFAULT_ID];
}
